<template>
    <div class="bibliometric-details">
        <div class="page-cont" v-loading="infoLoad">
            <h2 v-html="info.cnTitle"></h2>
            <!-- <p class="author">{{info.author}}--({{info.year}})</p>  --> 
            <div class="info" v-if='info.author'>
                <p class="label">作者:</p>
                <div class="txt">{{info.author}}</div>
            </div>
            <div class="info" v-if='info.authorAffiliation'>
                <p class="label">作者单位:</p>
                <div class="txt">{{info.authorAffiliation}}</div>
            </div>
            <div class="info" v-if='info.source'>
                <p class="label">来源:</p>
                <div class="txt">{{info.source}}</div>
            </div>
            <div class="info" v-if='info.year'>
                <p class="label">发表年份:</p>
                <div class="txt">{{info.year}}</div>
            </div>
            <div class="info" v-if='info.cnDigest'>
                <p class="label">中文文摘:</p>
                <div class="txt">{{info.cnDigest}}</div>
            </div>
            <div class="info" v-if='info.keyWord'>
                <p class="label">关键词:</p>
                <div class="txt">{{info.keyWord}}</div>
            </div> 
            <div class="info" v-if='info.classNum'>
                <p class="label">分类号: </p>
                <div class="txt">{{info.classNum}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import getRequest from '../../utils/getRequest.js';
import {bibliometricsInfo,getAnalysisPoolData} from '../../io/api.js'
export default {
    components: {},
    data() {
        return {
            infoLoad:false,
            infoId:this.$route.query.id||getRequest(window.location.href)[id],
            info:{},
            sourceType:this.$route.query.sourceType||'',
        }
    },
    watch: {},
    mounted() { 
        if(this.infoId){
            this.getInfo(this.infoId)
        }
    },
    methods: { 
        getInfo(id){
            this.infoLoad=true
            if(this.sourceType=='analysis'){
                getAnalysisPoolData(id).then(res=>{
                    let data = res.data;
                    if(data.code==0){
                        this.info=data.data
                    }else{
                        this.$message.error(data.msg||'请求失败～')
                    }
                    this.infoLoad=false
                })
            }else{
                bibliometricsInfo(id).then(res=>{
                    let data = res.data;
                    if(data.code==0){
                        this.info=data.data||{}
                    }else{
                        this.$message.error(data.msg||'请求失败～')
                    }
                    this.infoLoad=false
                })
            }
        }
    }
}
</script>
<style lang='less' scoped>
.bibliometric-details{
    padding-bottom: 40px;
    .info{
        width: 100%;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        line-height: 28px;
        margin-bottom: 10px;
        .label{
            width: 140px;
            text-align: right;
            font-weight: bold;
            // text-align-last: justify;
        }
        .txt{
            width: 1040px;
        }
    }
}
</style>